exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".InstagramAuthButton__button___1j6Xf {\n    background-color: #eee!important;\n    height: 2.4rem;\n    margin-bottom: 0.75rem!important;\n}\n\n.InstagramAuthButton__label___15U1C {\n    color: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["mainTextColour"] + ";\n\tdisplay: flex;\n    flex-direction: row;\n}\n\n.InstagramAuthButton__text___2nHP3 {\n    min-width: 11rem;\n}\n\n.InstagramAuthButton__logo___2H3EY {\n\theight: 1.5rem;\n    margin-right: 1.5rem;\n}\n\n.InstagramAuthButton__instaColour___1jPle {\n    color: #bc2a8d!important;\n}\n", ""]);

// exports
exports.locals = {
	"mainTextColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["mainTextColour"] + "",
	"inverseMainTextColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["inverseMainTextColour"] + "",
	"button": "InstagramAuthButton__button___1j6Xf",
	"label": "InstagramAuthButton__label___15U1C",
	"text": "InstagramAuthButton__text___2nHP3",
	"logo": "InstagramAuthButton__logo___2H3EY",
	"instaColour": "InstagramAuthButton__instaColour___1jPle"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/InstagramAuthButton.icss
// module id = 1561
// module chunks = 0